<app-profile-form
  [userToEdit]="currentUser"
  [canEdit]="canEdit"
  [displayEditButton]="true"
  [isCurrentUserIdNot]="isCurrentUserIdNot"
  (loadUser)="loadCurrentUser()"
></app-profile-form>
